import axios, { AxiosResponse } from 'axios';

export interface IisinZadostO {
    idzadosti: number;
    datumzmeny: string;
}

interface subj {
    subj: IisinZadostO[];
}

interface c2 {
    c2: subj;
}

export interface isin {
    isin: c2;
}
interface IZadostPostResp {
    datumzmeny: string;
    idzadosti: number;
}

export const isinZadostPost = (idmb: number, stat: string, isRegistration?: boolean) => {
    return axios({
        method: 'POST',
        url: isRegistration ? 'RegistraceISIN' : 'ZadostoISIN',
        data: {
            idmb: idmb,
            stat: stat
        }
    }).then((resp: AxiosResponse<IZadostPostResp>) => resp.data);
};

export interface INaceData {
    nacelist: {
        nace: string;
        nacepopis: string;
    }[];
}

export const isinGetNaceList = () => {
    return axios({
        method: 'GET',
        url: '/ISIN/Nace'
    }).then((resp: AxiosResponse<INaceData>) => resp.data);
};
